// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__FkV9q","background":"Modal_background__HGx0v"};